import React, { useMemo, useRef, Dispatch, SetStateAction } from "react";
import styled from "styled-components";
import ReactQuill from "react-quill";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupDetailSectionProps {
  modalType?: string;
  detailContent: string;
  setDetailContent: Dispatch<SetStateAction<string>>;
}

export default function PopupDetailSection({
  modalType,
  detailContent,
  setDetailContent,
}: PopupDetailSectionProps) {
  const QuillRef = useRef<ReactQuill>();

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "bullet" }],
        ],
      },
    }),
    []
  );

  const markup = () => {
    if (detailContent !== "") {
      return { __html: detailContent };
    }
  };

  return (
    <>
      <ModalLabel style={{ marginBottom: 10 }}>
        {modalType === "view" ? "상세" : "상세 입력"}
      </ModalLabel>

      {modalType === "view" ? (
        <ViewDetail dangerouslySetInnerHTML={markup()} />
      ) : (
        <SQuill
          ref={(element) => {
            if (element !== null) {
              QuillRef.current = element;
            }
          }}
          value={detailContent}
          onChange={setDetailContent}
          modules={modules}
          placeholder="내용을 입력해주세요."
        />
      )}
    </>
  );
}

const SQuill = styled(ReactQuill)`
  .ql-container {
    height: 100px;
    margin-bottom: 20px;
  }

  ol,
  ul {
    padding-left: 16px;
  }

  li {
    padding-left: 0px;
  }

  strong {
    font-weight: bold;
  }
`;

export const ViewDetail = styled.div`
  margin-bottom: 20px;
cursor: not-allowed;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: 16px;
  resize: none;
  border: solid 1px transparent;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #808080;

  h3 {
    font-size: 15px;
    font-weight: bold;
  }

  ol,
  ul {
    padding-left: 16px;
  }

  li {
    padding-left: 0px;
  }

  ol > li {
    list-style: decimal;
  }

  ul > li {
    list-style: disc;
  }

  strong {
    font-weight: bold;
  }
`;
